// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-funnel-js {
  display: inline-block;
  position: relative;
}
.svg-funnel-js svg {
  display: block;
}
.svg-funnel-js .svg-funnel-js__labels {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__labels {
  flex-direction: column;
}
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.svg-funnel-js {
  font-family: Open Sans, sans-serif;
}
.svg-funnel-js .svg-funnel-js__container {
  width: 100%;
  height: 100%;
}
.svg-funnel-js .svg-funnel-js__labels {
  width: 100%;
  box-sizing: border-box;
}
.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label {
  flex: 1 1;
  position: relative;
}
.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__value {
  font-size: 24px;
  color: #fff;
  line-height: 18px;
  margin-bottom: 6px;
}
.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__title {
  font-size: 12px;
  font-weight: 700;
  color: #21ffa2;
}
.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__percentage {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}
.svg-funnel-js
  .svg-funnel-js__labels
  .svg-funnel-js__label
  .label__segment-percentages {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  left: 0;
  padding: 8px 24px;
  box-sizing: border-box;
  background-color: rgba(8, 7, 48, 0.8);
  margin-top: 24px;
  opacity: 0;
  transition: opacity 0.1s ease;
  cursor: default;
}
.svg-funnel-js
  .svg-funnel-js__labels
  .svg-funnel-js__label
  .label__segment-percentages
  ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.svg-funnel-js
  .svg-funnel-js__labels
  .svg-funnel-js__label
  .label__segment-percentages
  ul
  li {
  font-size: 13px;
  line-height: 16px;
  color: #fff;
  margin: 18px 0;
}
.svg-funnel-js
  .svg-funnel-js__labels
  .svg-funnel-js__label
  .label__segment-percentages
  ul
  li
  .percentage__list-label {
  font-weight: 700;
  color: #05df9d;
}
.svg-funnel-js
  .svg-funnel-js__labels
  .svg-funnel-js__label:hover
  .label__segment-percentages {
  opacity: 1;
}
.svg-funnel-js:not(.svg-funnel-js--vertical) {
  padding-top: 64px;
  padding-bottom: 16px;
}
.svg-funnel-js:not(.svg-funnel-js--vertical) .svg-funnel-js__label {
  padding-left: 24px;
}
.svg-funnel-js:not(.svg-funnel-js--vertical)
  .svg-funnel-js__label:not(:first-child) {
  border-left: 1px solid #fff;
}
.svg-funnel-js.svg-funnel-js--vertical {
  padding-left: 120px;
  padding-right: 16px;
}
.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__label {
  padding-top: 24px;
}
.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__label:not(:first-child) {
  border-top: 1px solid #fff;
}
.svg-funnel-js.svg-funnel-js--vertical
  .svg-funnel-js__label
  .label__segment-percentages {
  margin-top: 0;
  margin-left: 106px;
  width: calc(100% - 106px);
}
.svg-funnel-js.svg-funnel-js--vertical
  .svg-funnel-js__label
  .label__segment-percentages
  .segment-percentage__list {
  display: flex;
  justify-content: space-around;
}
.svg-funnel-js .svg-funnel-js__subLabels {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  position: absolute;
  width: 100%;
  left: 0;
}
.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel {
  display: flex;
  font-size: 12px;
  color: #fff;
  line-height: 16px;
}
.svg-funnel-js
  .svg-funnel-js__subLabels
  .svg-funnel-js__subLabel:not(:first-child) {
  margin-left: 16px;
}
.svg-funnel-js
  .svg-funnel-js__subLabels
  .svg-funnel-js__subLabel
  .svg-funnel-js__subLabel--color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 2px 8px 2px 0;
}

/* General styles for the card */
.styled-card {
  border-radius: 8px; /* Rounded corners */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  margin: 20px auto; /* Center the card */
  overflow: hidden; /* Hide overflow */
  font-family: 'Arial', sans-serif; /* Default font family */
  display: flex;
  align-items: center;
}

/* Content styles inside the card */
.card-content {
  padding: 20px; /* Padding inside the card */
  background-color: #fff; /* White background */
  display: flex;
  align-items: center;
}

/* Grid container to arrange items */
.grid-container {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr; /* Responsive layout with three columns */
  gap: 20px; /* Space between grid items */
}

/* Image container */
.image-container {
  display: flex;
  justify-content: center; /* Center image horizontally */
}

/* Image styles */
.image {
  width: 70%; /* Width of the image */
  height: auto; /* Maintain aspect ratio */
}

/* Text container styles */
.text-container {
  display: flex;
  flex-direction: column; /* Column layout for text */
  justify-content: center; /* Center text vertically */
}

/* Header styles */
.header {
  color: black;
  font-size: 24px; /* Font size for headers */
  font-weight: 600; /* Bold text */
  margin: 0; /* Remove default margin */
}

/* Description styles */
.description {
  font-size: 16px; /* Font size for descriptions */
  color: #555; /* Dark gray color for description text */
}

/* Input container styles */
.input-container {
  display: flex;
  flex-direction: column; /* Column layout for input */
  justify-content: center;
}

/* Input grid for email input and button */
.input-grid {
  display: flex;
  align-items: center; /* Center align items vertically */
  margin-bottom: 10px; /* Space below the input grid */
}

/* Email input styles */
.email-input {
  flex: 1 1; /* Take remaining space */
  padding: 10px; /* Padding for input */
  border: 1px solid #ccc; /* Light gray border */
  border-radius: 4px; /* Slightly rounded corners */
  font-size: 16px; /* Font size for input */
  margin-right: 10px; /* Space between input and button */
}

/* Checkbox label styles */
.checkbox-label {
  margin-top: 10px; /* Space above checkbox */
  font-size: 14px; /* Font size for checkbox label */
  display: flex; /* Flexbox for alignment */
  align-items: center; /* Center align items vertically */
}

/* Checkbox styles */
.checkbox-label input {
  margin-right: 5px; /* Space between checkbox and label */
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/UserDashboard/pages/Panel/Panel.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAGlB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;AACA;EAIE,sBAAsB;AACxB;AAGA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EAEX,sBAAsB;AACxB;AACA;EAGE,SAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;EAC3B,WAAW;EACX,OAAO;EACP,iBAAiB;EAEjB,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,UAAU;EAEV,6BAA6B;EAC7B,eAAe;AACjB;AACA;;;;;EAKE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;AACA;;;;;;EAME,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;AACA;;;;;;;EAOE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;;;EAME,aAAa;EAEb,6BAA6B;AAC/B;AACA;EAGE,aAAa;EAGb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;AACA;EAGE,aAAa;EACb,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;;EAIE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB,EAAE,oBAAoB;EACxC,wCAAwC,EAAE,kBAAkB;EAC5D,iBAAiB,EAAE,oBAAoB;EACvC,gBAAgB,EAAE,kBAAkB;EACpC,gCAAgC,EAAE,wBAAwB;EAC1D,aAAa;EACb,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa,EAAE,4BAA4B;EAC3C,sBAAsB,EAAE,qBAAqB;EAC7C,aAAa;EACb,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,kCAAkC,EAAE,yCAAyC;EAC7E,SAAS,EAAE,6BAA6B;AAC1C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB,EAAE,8BAA8B;AACzD;;AAEA,iBAAiB;AACjB;EACE,UAAU,EAAE,uBAAuB;EACnC,YAAY,EAAE,0BAA0B;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,uBAAuB,EAAE,2BAA2B;AACtD;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe,EAAE,0BAA0B;EAC3C,gBAAgB,EAAE,cAAc;EAChC,SAAS,EAAE,0BAA0B;AACvC;;AAEA,uBAAuB;AACvB;EACE,eAAe,EAAE,+BAA+B;EAChD,WAAW,EAAE,yCAAyC;AACxD;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB,EAAE,4BAA4B;EACpD,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB,EAAE,kCAAkC;EACvD,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA,uBAAuB;AACvB;EACE,SAAO,EAAE,yBAAyB;EAClC,aAAa,EAAE,sBAAsB;EACrC,sBAAsB,EAAE,sBAAsB;EAC9C,kBAAkB,EAAE,6BAA6B;EACjD,eAAe,EAAE,wBAAwB;EACzC,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,eAAe,EAAE,iCAAiC;EAClD,aAAa,EAAE,0BAA0B;EACzC,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA,oBAAoB;AACpB;EACE,iBAAiB,EAAE,qCAAqC;AAC1D","sourcesContent":[".svg-funnel-js {\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n.svg-funnel-js svg {\r\n  display: block;\r\n}\r\n.svg-funnel-js .svg-funnel-js__labels {\r\n  position: absolute;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__labels {\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n}\r\n\r\n@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');\r\nbody {\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n.svg-funnel-js {\r\n  font-family: Open Sans, sans-serif;\r\n}\r\n.svg-funnel-js .svg-funnel-js__container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.svg-funnel-js .svg-funnel-js__labels {\r\n  width: 100%;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1 1 0px;\r\n  flex: 1 1 0;\r\n  position: relative;\r\n}\r\n.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__value {\r\n  font-size: 24px;\r\n  color: #fff;\r\n  line-height: 18px;\r\n  margin-bottom: 6px;\r\n}\r\n.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__title {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: #21ffa2;\r\n}\r\n.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__percentage {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #fff;\r\n}\r\n.svg-funnel-js\r\n  .svg-funnel-js__labels\r\n  .svg-funnel-js__label\r\n  .label__segment-percentages {\r\n  position: absolute;\r\n  top: 50%;\r\n  -webkit-transform: translateY(-50%);\r\n  transform: translateY(-50%);\r\n  width: 100%;\r\n  left: 0;\r\n  padding: 8px 24px;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  background-color: rgba(8, 7, 48, 0.8);\r\n  margin-top: 24px;\r\n  opacity: 0;\r\n  -webkit-transition: opacity 0.1s ease;\r\n  transition: opacity 0.1s ease;\r\n  cursor: default;\r\n}\r\n.svg-funnel-js\r\n  .svg-funnel-js__labels\r\n  .svg-funnel-js__label\r\n  .label__segment-percentages\r\n  ul {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style-type: none;\r\n}\r\n.svg-funnel-js\r\n  .svg-funnel-js__labels\r\n  .svg-funnel-js__label\r\n  .label__segment-percentages\r\n  ul\r\n  li {\r\n  font-size: 13px;\r\n  line-height: 16px;\r\n  color: #fff;\r\n  margin: 18px 0;\r\n}\r\n.svg-funnel-js\r\n  .svg-funnel-js__labels\r\n  .svg-funnel-js__label\r\n  .label__segment-percentages\r\n  ul\r\n  li\r\n  .percentage__list-label {\r\n  font-weight: 700;\r\n  color: #05df9d;\r\n}\r\n.svg-funnel-js\r\n  .svg-funnel-js__labels\r\n  .svg-funnel-js__label:hover\r\n  .label__segment-percentages {\r\n  opacity: 1;\r\n}\r\n.svg-funnel-js:not(.svg-funnel-js--vertical) {\r\n  padding-top: 64px;\r\n  padding-bottom: 16px;\r\n}\r\n.svg-funnel-js:not(.svg-funnel-js--vertical) .svg-funnel-js__label {\r\n  padding-left: 24px;\r\n}\r\n.svg-funnel-js:not(.svg-funnel-js--vertical)\r\n  .svg-funnel-js__label:not(:first-child) {\r\n  border-left: 1px solid #fff;\r\n}\r\n.svg-funnel-js.svg-funnel-js--vertical {\r\n  padding-left: 120px;\r\n  padding-right: 16px;\r\n}\r\n.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__label {\r\n  padding-top: 24px;\r\n}\r\n.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__label:not(:first-child) {\r\n  border-top: 1px solid #fff;\r\n}\r\n.svg-funnel-js.svg-funnel-js--vertical\r\n  .svg-funnel-js__label\r\n  .label__segment-percentages {\r\n  margin-top: 0;\r\n  margin-left: 106px;\r\n  width: calc(100% - 106px);\r\n}\r\n.svg-funnel-js.svg-funnel-js--vertical\r\n  .svg-funnel-js__label\r\n  .label__segment-percentages\r\n  .segment-percentage__list {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: distribute;\r\n  justify-content: space-around;\r\n}\r\n.svg-funnel-js .svg-funnel-js__subLabels {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  margin-top: 24px;\r\n  position: absolute;\r\n  width: 100%;\r\n  left: 0;\r\n}\r\n.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  font-size: 12px;\r\n  color: #fff;\r\n  line-height: 16px;\r\n}\r\n.svg-funnel-js\r\n  .svg-funnel-js__subLabels\r\n  .svg-funnel-js__subLabel:not(:first-child) {\r\n  margin-left: 16px;\r\n}\r\n.svg-funnel-js\r\n  .svg-funnel-js__subLabels\r\n  .svg-funnel-js__subLabel\r\n  .svg-funnel-js__subLabel--color {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  margin: 2px 8px 2px 0;\r\n}\r\n\r\n/* General styles for the card */\r\n.styled-card {\r\n  border-radius: 8px; /* Rounded corners */\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */\r\n  margin: 20px auto; /* Center the card */\r\n  overflow: hidden; /* Hide overflow */\r\n  font-family: 'Arial', sans-serif; /* Default font family */\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Content styles inside the card */\r\n.card-content {\r\n  padding: 20px; /* Padding inside the card */\r\n  background-color: #fff; /* White background */\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Grid container to arrange items */\r\n.grid-container {\r\n  display: grid;\r\n  grid-template-columns: 1fr 2fr 2fr; /* Responsive layout with three columns */\r\n  gap: 20px; /* Space between grid items */\r\n}\r\n\r\n/* Image container */\r\n.image-container {\r\n  display: flex;\r\n  justify-content: center; /* Center image horizontally */\r\n}\r\n\r\n/* Image styles */\r\n.image {\r\n  width: 70%; /* Width of the image */\r\n  height: auto; /* Maintain aspect ratio */\r\n}\r\n\r\n/* Text container styles */\r\n.text-container {\r\n  display: flex;\r\n  flex-direction: column; /* Column layout for text */\r\n  justify-content: center; /* Center text vertically */\r\n}\r\n\r\n/* Header styles */\r\n.header {\r\n  color: black;\r\n  font-size: 24px; /* Font size for headers */\r\n  font-weight: 600; /* Bold text */\r\n  margin: 0; /* Remove default margin */\r\n}\r\n\r\n/* Description styles */\r\n.description {\r\n  font-size: 16px; /* Font size for descriptions */\r\n  color: #555; /* Dark gray color for description text */\r\n}\r\n\r\n/* Input container styles */\r\n.input-container {\r\n  display: flex;\r\n  flex-direction: column; /* Column layout for input */\r\n  justify-content: center;\r\n}\r\n\r\n/* Input grid for email input and button */\r\n.input-grid {\r\n  display: flex;\r\n  align-items: center; /* Center align items vertically */\r\n  margin-bottom: 10px; /* Space below the input grid */\r\n}\r\n\r\n/* Email input styles */\r\n.email-input {\r\n  flex: 1; /* Take remaining space */\r\n  padding: 10px; /* Padding for input */\r\n  border: 1px solid #ccc; /* Light gray border */\r\n  border-radius: 4px; /* Slightly rounded corners */\r\n  font-size: 16px; /* Font size for input */\r\n  margin-right: 10px; /* Space between input and button */\r\n}\r\n\r\n/* Checkbox label styles */\r\n.checkbox-label {\r\n  margin-top: 10px; /* Space above checkbox */\r\n  font-size: 14px; /* Font size for checkbox label */\r\n  display: flex; /* Flexbox for alignment */\r\n  align-items: center; /* Center align items vertically */\r\n}\r\n\r\n/* Checkbox styles */\r\n.checkbox-label input {\r\n  margin-right: 5px; /* Space between checkbox and label */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
